import { Cart } from "@insite/client-framework/Services/CartService";
import { PaymentMethodDto } from "@insite/client-framework/Types/ApiModels";

export const isZeroTotalCheckout = (orderGrandTotal: number | null | undefined): boolean => orderGrandTotal === 0;

export const clearZeroTotalPayment = (cart: Cart): boolean => {
    if (!isZeroTotalCheckout(cart.orderGrandTotal)) {
        return false;
    }

    cart.paymentMethod = null;
    if (cart.paymentOptions) {
        cart.paymentOptions = {
            ...cart.paymentOptions,
            paymentMethods: [],
            creditCard: null,
            eCheck: null,
            storePaymentProfile: false,
            isPayPal: false,
            payPalToken: "",
            payPalPayerId: "",
            payerId: "",
            isAdyenDropIn: false,
            adyenPspReference: "",
            isBnpl: false,
            bnplTransactionToken: "",
            bnplClientSecret: "",
        };
    }
    return true;
};

interface ResolveCheckoutPaymentMethodParameters {
    currentPaymentMethod: string;
    persistedPaymentMethod?: Pick<PaymentMethodDto, "name"> | null;
    visiblePaymentMethods: Pick<PaymentMethodDto, "name" | "isCreditCard">[];
    termsMethod?: Pick<PaymentMethodDto, "name"> | null;
    isPayOnTerms: boolean;
}

/**
 * Resolves the local method used by checkout while the shopper compares Payment Options.
 * The method is persisted atomically with the selected split choice when the order is placed.
 */
export const resolveCheckoutPaymentMethod = ({
    currentPaymentMethod,
    persistedPaymentMethod,
    visiblePaymentMethods,
    termsMethod,
    isPayOnTerms,
}: ResolveCheckoutPaymentMethodParameters): string => {
    if (isPayOnTerms) {
        return termsMethod?.name || currentPaymentMethod;
    }

    if (visiblePaymentMethods.some(method => method.name === currentPaymentMethod)) {
        return currentPaymentMethod;
    }

    if (persistedPaymentMethod && visiblePaymentMethods.some(method => method.name === persistedPaymentMethod.name)) {
        return persistedPaymentMethod.name;
    }

    return visiblePaymentMethods.find(method => method.isCreditCard)?.name || "";
};
